module.exports = __webpack_public_path__ + "static/media/icon-questions.7c2d4d75.svg";